import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const languageApi = generateNomenApi(`/nomen/language`);

export const languageOptions = generateNomenOptions('language', languageApi);
